module.exports = __webpack_public_path__ + "img/double_star.fc3c6cc9.png";